__webpack_require__.p = "/natural-hazards/";